import {FileItemSelection} from "./ProductCatalogLookup";
import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useContext, useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {TableClickBoundary} from "../../../../misc/scroller/TableClickBoundary";
import {ConfirmContext} from "../../../../misc/Confirm";

export function FileEditDialog<T extends Pick<FileItemSelection, "id" | "name">>(props: {
    value: T;
    onRename(value: T): Promise<any>;
    onClose(): void;
}) {

    const ext = props.value.name.match(/\.[A-z]+$/g)?.[0] ?? "";
    const [name, setName] = useState(removeExt(props.value.name, ext));

    const updateRef = useSyncedRef(props.onRename);
    const onCloseRef = useSyncedRef(props.onClose);

    const update = useAsyncAction(async (input) => {
        await updateRef.current(input);
        onCloseRef.current();
    }, []);

    const confirm = useContext(ConfirmContext);

    return (
        <Dialog2 open onClose={() => props.onClose()}>
            <TableClickBoundary>
                <DialogTitle>
                    Edit {props.value.name}
                </DialogTitle>
                <DialogContent>
                   <div style={{height: 8}} />
                   <TextField label={"Name"}
                              value={name}
                              onChange={e => setName(e.target.value)}
                   />
                </DialogContent>
                <SmoothActionBar
                    loading={update.loading}
                    error={update.error}
                    actionName="Rename"
                    submitDisabled={!name}
                    onSubmit={() => {
                        update.callback({
                            ...props.value,
                            name: name + ext,
                        })
                    }}
                    onCancel={() => props.onClose()}
                    onDestroy={async () => {
                        const ok = await confirm.confirm("Are you sure you want to archive this file?")
                        if(!ok) return;

                        update.callback({
                            ...props.value,
                            archived: true,
                        })
                    }}
                    destroyLoading={update.loading}
                    destroyName="Archive"
                    destroyingWord="Archiving…"
                />
            </TableClickBoundary>
        </Dialog2>
    )
}

function removeExt(file: string, ext: string) {
    if(file.endsWith(ext)) {
        return file.slice(0, file.length - ext.length);
    }

    return file;
}